import React, { useState } from 'react'
import ScrollerPage from '../containers/commons/ScrollerPage'
import WindowDimensionsPage from '../containers/commons/WindowDimensionsPage'
import HeaderPage from '../containers/layout/HeaderPage'
import SidebarPage from '../containers/layout/SidebarPage'
import DocumentEditionPage from '../containers/dossiers/commons/DocumentEdition'
import DocumentHistoricalEditionPage from '../containers/dossierHistorical/common/DocumentEdition'
import MessageModalContainer from '../containers/layout/modals/MessageModalContainer'
import ModalDocumentFullScreenPage from '../containers/dossiers/common/ModalDocumentFullScreenPage'

import ReleaseNotesModalPage from '../containers/layout/modals/ReleaseNotesModalContainer'
import ChangePasswordModalPage from '../containers/layout/modals/ChangePasswordModalContainer'
import PasswordExpirationModalContainer from '../containers/layout/modals/PasswordExpirationModalContainer'

import settings from '../../src/setting'

import { setStorageValue, getStorageValue } from '../storage/storage'

function getEnviromentClass () {
  if (settings.environmentName.includes('test')) {
    return 'test'
  }
  if (settings.environmentName.includes('qa')) {
    return 'qa'
  }
  if (settings.environmentName.includes('pre')) {
    return 'pre'
  }
  return ''
}

export default ({ children }) => {
  const [openSideBar, setOpenMenu] = useState(getStorageValue('mobileMenuIsClose') === 'true')

  const openMenu = () => {
    setStorageValue('mobileMenuIsClose', !openSideBar)
    setOpenMenu(!openSideBar)
  }

  return (
    <div className={'mainGrid customScrollbar mVersion ' + (openSideBar ? 'displayedMenu' : '')}>
      <div className='gridPart-header'><HeaderPage /></div>
      <div className='gridPart-leftnav'><SidebarPage openMenu={openMenu} openSideBar={openSideBar} /></div>
      <div className='gridPart-content'>
        <ChangePasswordModalPage />
        <PasswordExpirationModalContainer />
        <ReleaseNotesModalPage />
        <MessageModalContainer />
        <DocumentEditionPage />
        <DocumentHistoricalEditionPage />
        <ModalDocumentFullScreenPage />
        <ScrollerPage />
        <WindowDimensionsPage />
        { children }
      </div>
      { getEnviromentClass() !== ''
        ? <div className={'gridPart-enviroment ' + getEnviromentClass()}><p>{settings.environmentName}</p></div>
        : <></>
      }
    </div>
  )
}
